export const rootForV1API = `${process.env.REACT_APP_API_DOTNET}/api/v1`;

export const styles = theme => ({
    content: {
        flexGrow: 1,
        margin: '30px 0 0 22px'
    },
    topButtonsContainer: {
        display: 'flex',
    },
    sideBar: {
        minWidth: 790,
        width: 790,
    },
    modalText: {
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16,
        color: '#3A3A3A'
    },
    topButtons: {
        display: 'flex',
        justifyContent: "space-between"
    }
});

export const parseHyperfindQueries = (hyperfindQueries) => {
    let newHyperfindQueries = [];
    for (let query of hyperfindQueries) {
        newHyperfindQueries.push({
            value: query.id,
            label: query.name,
            desc: query.description,
            visibility: query.visibility
        })
    }
    return newHyperfindQueries;
};
